import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_tactiq-campaigns/artifacts/sjma7cgr_Tactiq%20Logo%20WBKG-01.png";

// Official Tactiq logo (image asset — includes the Q mark + TACTIQ wordmark).
// `dark` inverts the logo (for use on the navy footer or dark sections).
// `withTag` shows the small "Custom Label Water Bottles" tagline underneath.
export const TactiqLogo = ({ className = "", dark = false, withTag = false, size = 56 }) => {
  const accent = dark ? "#93C5FD" : "#0A2A6B";
  return (
    <div className={`flex items-center gap-3 leading-none ${className}`}>
      <img
        src={LOGO_URL}
        alt="Tactiq"
        style={{
          height: size,
          width: "auto",
          objectFit: "contain",
          filter: dark ? "invert(1) brightness(1.1)" : "none",
        }}
        draggable={false}
      />
      {withTag && (
        <span
          className="hidden md:block font-mono uppercase whitespace-nowrap"
          style={{
            color: accent,
            fontSize: "0.55rem",
            letterSpacing: "0.28em",
            lineHeight: 1.5,
          }}
        >
          Custom Label
          <br />
          Water Bottles
        </span>
      )}
    </div>
  );
};

// Stylized bottle SVG with customizable label color and uploaded logo
export const BottleSVG = ({
  labelColor = "#0A2A6B",
  brandText = "TACTIQ",
  tagline = "YOUR BRAND. EVERY SIP.",
  logoDataUrl = null,
  className = "",
  textColor = "#ffffff",
}) => {
  return (
    <svg
      viewBox="0 0 220 520"
      xmlns="http://www.w3.org/2000/svg"
      className={`bottle-shadow ${className}`}
      role="img"
      aria-label="Custom labeled bottle preview"
    >
      <defs>
        <linearGradient id="bottleBody" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#e6efff" stopOpacity="0.85" />
          <stop offset="35%" stopColor="#ffffff" stopOpacity="0.95" />
          <stop offset="65%" stopColor="#dbeafe" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#bfdbfe" stopOpacity="0.6" />
        </linearGradient>
        <linearGradient id="capGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1f2937" />
          <stop offset="100%" stopColor="#0a0a0a" />
        </linearGradient>
        <clipPath id="labelClip">
          <rect x="22" y="180" width="176" height="200" rx="4" />
        </clipPath>
      </defs>

      {/* Cap */}
      <rect x="78" y="6" width="64" height="46" rx="6" fill="url(#capGrad)" />
      <rect x="76" y="46" width="68" height="10" rx="2" fill="#0a0a0a" />

      {/* Neck */}
      <path
        d="M82 56 L82 110 Q82 130 60 150 L60 470 Q60 510 110 510 Q160 510 160 470 L160 150 Q138 130 138 110 L138 56 Z"
        fill="url(#bottleBody)"
        stroke="#cbd5e1"
        strokeWidth="1.5"
      />

      {/* Subtle water highlight */}
      <path
        d="M72 170 Q70 300 80 470"
        stroke="rgba(255,255,255,0.7)"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M148 200 Q150 340 142 460"
        stroke="rgba(255,255,255,0.5)"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />

      {/* Label */}
      <g clipPath="url(#labelClip)">
        <rect x="22" y="180" width="176" height="200" fill={labelColor} />
        {/* Diagonal accent */}
        <path d="M22 350 L198 280 L198 380 L22 380 Z" fill="rgba(255,255,255,0.08)" />
        {/* Logo or brand text */}
        {logoDataUrl ? (
          <image
            href={logoDataUrl}
            x="46"
            y="220"
            width="128"
            height="80"
            preserveAspectRatio="xMidYMid meet"
          />
        ) : (
          <text
            x="110"
            y="270"
            textAnchor="middle"
            fontFamily="Cabinet Grotesk, Space Grotesk, sans-serif"
            fontWeight="900"
            fontSize="32"
            letterSpacing="-1"
            fill={textColor}
          >
            {brandText}
          </text>
        )}
        {/* Water drop accent */}
        <path
          d="M148 244 C148 250 154 252 154 256 A3 3 0 0 1 142 256 C142 252 148 250 148 244 Z"
          fill="rgba(255,255,255,0.7)"
        />
        {/* Tagline */}
        <text
          x="110"
          y="338"
          textAnchor="middle"
          fontFamily="JetBrains Mono, monospace"
          fontWeight="600"
          fontSize="9"
          letterSpacing="2"
          fill={textColor}
          opacity="0.85"
        >
          {tagline}
        </text>
      </g>
      {/* Label borders */}
      <rect
        x="22"
        y="180"
        width="176"
        height="200"
        rx="4"
        fill="none"
        stroke="rgba(0,0,0,0.12)"
        strokeWidth="1"
      />
    </svg>
  );
};
